import styled from './container.module.scss';

const Container = ({ children }) => {
    return (
        <div className={styled['container']}>
            {children}
        </div>
    )
}

export default Container;